import config from "../config";
import { sendGetRequest, sendPostRequest } from "../Utility/FetchUtils";
import { SmtpSetting } from "../Model/SmtpSetting";
import { NotificationTest } from "../Model/TestEmail";
import { EAutoCalibrationResult } from "../Model/EAutoCalibrationResult";
import { ModuleWaypoint } from "../Model/Waypoint";
import { ENotificationTest } from "../Model/ENotificationTest";
import { ESlotCorrectionResultType, SlotCorrectionResult } from "../Model/SlotCorrection";

export default class ToolsApi {
  static BASE_URL = config.SERVICE_URL + "/Tools";

  static getSmtpSetting() {
    const url = this.BASE_URL + "/smtp";
    return sendGetRequest<SmtpSetting>(url);
  }

  static sendTestEmail(notificationTest: NotificationTest) {
    const url = this.BASE_URL + "/notification/:send";
    return sendPostRequest(url, notificationTest);
  }

  static runFullDiagnostic() {
    const url = this.BASE_URL + "/diagnostic/:full";
    return sendPostRequest(url);
  }

  static runMotorDiagnostic() {
    const url = this.BASE_URL + "/diagnostic/:motor";
    return sendPostRequest(url);
  }

  static ignoreDiagnosticError(ignore: boolean) {
    const url = this.BASE_URL + `/diagnostic/:ignore/${ignore}`;
    return sendPostRequest(url);
  }

  static home() {
    const url = this.BASE_URL + "/:home";
    return sendPostRequest(url);
  }

  static whiteBalance() {
    const url = this.BASE_URL + "/:white-balance";
    return sendPostRequest(url);
  }

  static retrievePlate(
    moduleIdentifier: string,
    hotelNumber: number,
    slotNumber: number,
    autoCalibrationResult: EAutoCalibrationResult
  ) {
    const url = `${this.BASE_URL}/:retrieve-plate/${moduleIdentifier}/${hotelNumber}/${slotNumber}/${autoCalibrationResult}`;
    return sendPostRequest(url);
  }

  static storePlate(
    moduleIdentifier: string,
    hotelNumber: number,
    slotNumber: number,
    autoCalibrationResult: EAutoCalibrationResult
  ) {
    const url = `${this.BASE_URL}/:store-plate/${moduleIdentifier}/${hotelNumber}/${slotNumber}/${autoCalibrationResult}`;
    return sendPostRequest(url);
  }

  static retrievePlateWithOverrideWaypoint(
    moduleIdentifier: string,
    hotelNumber: number,
    slotNumber: number,
    autoCalibrationResult: EAutoCalibrationResult,
    moduleWaypoint: ModuleWaypoint
  ) {
    const url = `${this.BASE_URL}/:retrieve-plate-override/${moduleIdentifier}/${hotelNumber}/${slotNumber}/${autoCalibrationResult}`;
    return sendPostRequest(url, moduleWaypoint);
  }

  static storePlateWithOverrideWaypoint(
    moduleIdentifier: string,
    hotelNumber: number,
    slotNumber: number,
    autoCalibrationResult: EAutoCalibrationResult,
    moduleWaypoint: ModuleWaypoint
  ) {
    const url = `${this.BASE_URL}/:store-plate-override/${moduleIdentifier}/${hotelNumber}/${slotNumber}/${autoCalibrationResult}`;
    return sendPostRequest(url, moduleWaypoint);
  }

  static retrievePlateWithOverrideSlotCorrection(
    moduleIdentifier: string,
    hotelNumber: number,
    slotNumber: number,
    autoCalibrationResult: EAutoCalibrationResult,
    slotCorrectionResult: SlotCorrectionResult,
  ) {
    const url = `${this.BASE_URL}/:retrieve-plate/${moduleIdentifier}/${hotelNumber}/${slotNumber}/${autoCalibrationResult}`;
    return sendPostRequest(url, slotCorrectionResult);
  }

  static storePlateWithOverrideSlotCorrection(
    moduleIdentifier: string,
    hotelNumber: number,
    slotNumber: number,
    autoCalibrationResult: EAutoCalibrationResult,
    slotCorrectionResult: SlotCorrectionResult,
  ) {
    const url = `${this.BASE_URL}/:store-plate/${moduleIdentifier}/${hotelNumber}/${slotNumber}/${autoCalibrationResult}`;
    return sendPostRequest(url, slotCorrectionResult);
  }

  static imagerPlateBump(
    moduleIdentifier: string,
  ) {
    const url = `${this.BASE_URL}/imager/${moduleIdentifier}:do-plate-bump`;
    return sendPostRequest(url);
  }

  static setDebugFilter(levelFilter: number) {
    const url = `${this.BASE_URL}/debug/:set-level-filter/${levelFilter}`;
    return sendPostRequest(url);
  }

  static barcodeScannerStart() {
    const url = `${this.BASE_URL}/barcode-scanner/:start`;
    return sendPostRequest(url);
  }

  static barcodeScannerStop() {
    const url = `${this.BASE_URL}/barcode-scanner/:stop`;
    return sendPostRequest(url);
  }

  static getNotificationTestSenderEmail() {
    const url = this.BASE_URL + "/notification/sender/email";
    return sendGetRequest<string>(url);
  }

  static getNotificationTestRecipientEmails(
    notificationTestType: ENotificationTest
  ) {
    const url = `${this.BASE_URL}/notification/recipient/email/${notificationTestType}`;
    return sendGetRequest<string[]>(url);
  }
}
